import { motion } from "framer-motion";
import { apartments } from "@/data/apartments";
import ApartmentCard from "@/components/ApartmentCard";

export default function ApartmentsSection() {
  return (
    <section
      id="apartments"
      data-testid="apartments-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="max-w-2xl"
          >
            <div className="text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-4">
              Portfolio & Case Studies
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-[#2B3324] leading-[1.1]">
              A selection of{" "}
              <span className="italic text-[#6E7F5B]">assets we advise on</span>
              .
            </h2>
            <div className="gold-accent mt-5" />
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="text-[#5C6B4D] font-light leading-relaxed max-w-md text-base"
          >
            From a hidden Soho retreat to an air-conditioned residence on
            Trafalgar Square — a curated look at the prime London properties
            for which we have delivered advisory, refurbishment oversight, or
            operator selection mandates.
          </motion.p>
        </div>

        <div
          data-testid="apartments-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {apartments.map((a, i) => (
            <ApartmentCard key={a.id} apartment={a} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
